import { SET_CURRENT_CUSTOMER, CurrentCustomerActionTypes } from '../actionTypes';

const setCurrentCustomer = (customer: string): CurrentCustomerActionTypes => ({
  type: SET_CURRENT_CUSTOMER,
  payload: customer,
});

export default setCurrentCustomer;
